import {
  styled,
  Tooltip,
  tooltipClasses,
  TooltipProps,
} from "@mui/material";

export const CustomTooltip = styled(({ className, ...props }: TooltipProps) => (
  <Tooltip {...props} arrow classes={{ popper: className }} />
))(() => ({
  [`& .${tooltipClasses.tooltip}`]: {
    backgroundColor: "#2f2f2f",
    color: "#ffffff",
    fontSize: 12,
    fontWeight: 500,
    padding: "6px 10px",
    borderRadius: 6,
  },
  [`& .${tooltipClasses.arrow}`]: {
    color: "#2f2f2f",
  },
}));
